import { render, staticRenderFns } from "./EmpresaIndex.vue?vue&type=template&id=b608aaa4&scoped=true&"
import script from "./EmpresaIndex.vue?vue&type=script&lang=ts&"
export * from "./EmpresaIndex.vue?vue&type=script&lang=ts&"
import style0 from "./EmpresaIndex.vue?vue&type=style&index=0&id=b608aaa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b608aaa4",
  null
  
)

export default component.exports